import React, { useState, useEffect, useCallback } from 'react';
import { observer } from 'mobx-react';
import HeaderRowSpanDataTable from 'components/data-table/HeaderRowSpanDataTable';
import MultiSelect from 'react-multi-select-component';
import moment from 'moment';
import models from 'models';
import { $qb } from 'scripts/querybuilder';
import { useServices } from 'hooks/useServices';
import DatePicker from 'components/common/DatePicker';

const SurgeryStatistics = () => {
  const services = useServices();

  const defaultParams = $qb()
    .limit(20)
    .orderBy('salesFigures desc')
    .customParam(
      'searchStartAt',
      moment(new Date().setDate(new Date().getDate() - 31)).format('YYYY-MM-DD')
    )
    .customParam(
      'searchEndAt',
      moment(new Date().setDate(new Date().getDate() - 1)).format('YYYY-MM-DD')
    );
  const [params, setParams] = useState(defaultParams);
  const [searchValue, setSearchValue] = useState({
    searchStartAt: moment(new Date().setDate(new Date().getDate() - 31)).format(
      'YYYY-MM-DD'
    ),
    searchEndAt: moment(new Date().setDate(new Date().getDate() - 1)).format(
      'YYYY-MM-DD'
    ),
  });
  const [startAt, setStartAt] = useState(
    new Date().setDate(new Date().getDate() - 31)
  );
  const [endAt, setEndAt] = useState(
    new Date().setDate(new Date().getDate() - 1)
  );
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [model, setModel] = useState(models.crm.surgeryCategoryStatistics);
  const [tabName, setTabName] = useState('category');
  const [treatmentItemCategories, setTreatmentItemCategories] = useState([]);
  const [treatmentItems, setTreatmentItems] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  const categoryStatisticsCallApi = useCallback(async () => {
    let paramId = '';
    if (params.queryParams && params.queryParams.paramTemp) {
      paramId = params.queryParams.paramTemp;
      delete params.queryParams.paramTemp;
    }
    const resp = await services.crm.statistics.statistics.treatment_category(
      params.build(),
      paramId
    );
    if (!resp) return;
    resp.data.treatmentCategoryData.map((v, i) => {
      let page = params.queryParams.page || 1;
      let limit = params.queryParams.limit;
      let no = parseInt((page - 1) * limit + (i + 1));
      v.no = no;
      return v;
    });

    setData(resp.data.treatmentCategoryData);
    setTotal(resp.meta.pagination.total);
    setModel(models.crm.surgeryCategoryStatistics);
  }, [services.crm.statistics, params, models.crm.surgeryCategoryStatistics]);

  useEffect(() => {
    categoryStatisticsCallApi();
  }, [categoryStatisticsCallApi]);

  const itemStatisticsCallApi = useCallback(async () => {
    let paramId = '';
    if (params.queryParams && params.queryParams.paramTemp) {
      paramId = params.queryParams.paramTemp;
      delete params.queryParams.paramTemp;
    }
    const resp = await services.crm.statistics.statistics.treatment_item(
      params.build(),
      paramId
    );
    if (!resp) return;
    resp.data.treatmentItemData.map((v, i) => {
      let page = params.queryParams.page || 1;
      let limit = params.queryParams.limit;
      let no = parseInt((page - 1) * limit + (i + 1));
      v.no = no;
      return v;
    });

    setData(resp.data.treatmentItemData);
    setTotal(resp.meta.pagination.total);
    setModel(models.crm.surgeryItemStatistics);
  }, [services.crm.statistics, params, models.crm.surgeryItemStatistics]);

  const treatmentItemCategoriesCallApi = useCallback(async () => {
    try {
      let params = { limit: 10000, visible: true };
      const resp = await services.crm.treatment.categories.items_categories_v2(
        params
      );
      if (!resp) return;

      const result = resp.data.map((v) => {
        v.label = v.name;
        v.value = v.id;

        return { label: v.name, value: v.id };
      });

      setTreatmentItemCategories(result);
    } catch (e) {
      console.log(e.description);
    }
  }, [services.crm.treatment.categories]);

  useEffect(() => {
    treatmentItemCategoriesCallApi();
  }, [treatmentItemCategoriesCallApi]);

  const treatmentItemCallApi = useCallback(async () => {
    try {
      let params = { limit: 10000, visible: true };
      const resp = await services.crm.treatment.items.all_v2(params);
      if (!resp) return;

      const result = resp.data.map((v) => {
        v.label = v.name;
        v.value = v.id;

        return { label: v.name, value: v.id };
      });

      setTreatmentItems(result);
    } catch (e) {
      console.log(e.description);
    }
  }, [services.crm.treatment]);

  useEffect(() => {
    treatmentItemCallApi();
  }, [treatmentItemCallApi]);

  const onParams = (p) => {
    setParams(p);
    callApi(tabName);
  };

  const callApi = (type) => {
    if (type === 'item') {
      itemStatisticsCallApi();
    } else if (type === 'category') {
      categoryStatisticsCallApi();
    }
  };

  /*const onClickSelectDate = (v) => {
    const now = new Date();
    if (v === 'month') {
      onChangeDate(
        new Date(now.getFullYear(), now.getMonth(), 1),
        new Date(now.getFullYear(), now.getMonth() + 1, 0)
      );
    } else if (v === 'week') {
      const nowDayOfWeek = now.getDay();
      const nowDay = now.getDate();
      const nowMonth = now.getMonth();
      let nowYear = now.getYear();
      nowYear += nowYear < 2000 ? 1900 : 0;
      const weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek);
      const weekEndDate = new Date(
        nowYear,
        nowMonth,
        nowDay + (6 - nowDayOfWeek)
      );
      onChangeDate(weekStartDate, weekEndDate);
    } else if (v === 'quarter') {
      const currentMonth = now.getMonth() + 1;
      const quarter = Math.ceil(currentMonth / 3);
      const startDate = new Date(now.getFullYear(), (quarter - 1) * 3, 1);
      const endDate = new Date(now.getFullYear(), quarter * 3, 0);
      onChangeDate(startDate, endDate);
    }
  };
  const onChangeDate = (startDate, endDate) => {
    setStartAt(startDate);
    setEndAt(endDate);
    setSearchValue({
      ...searchValue,
      searchStartAt: moment(startDate).format('YYYY-MM-DD'),
      searchEndAt: moment(endDate).format('YYYY-MM-DD'),
    });
  };*/

  const onChangeStartAt = (date) => {
    const searchStartAt = moment(date).format('YYYY-MM-DD');
    setStartAt(date);
    setSearchValue({ ...searchValue, searchStartAt });
  };

  const onChangeEndAt = (date) => {
    const searchEndAt = moment(date).format('YYYY-MM-DD');
    setEndAt(date);
    setSearchValue({ ...searchValue, searchEndAt });
  };

  const onClickHeaderRow = (row) => {
    let orderBy = `${row.column} ${row.order}`;
    let searchParam = searchValue;
    params.orderBy(orderBy);

    if (tabName === 'category') {
      if (selectedCategory.length > 0) {
        let search = new URLSearchParams(
          selectedCategory.map((s) => ['treatmentCategoryIds', s.value])
        );
        searchParam.paramTemp = search.toString();
      }
      params.queryParams = {
        limit: params.queryParams.limit,
        orderBy: params.queryParams.orderBy,
        ...searchParam,
      };
      setParams(params);
      categoryStatisticsCallApi();
    } else {
      if (selectedItems.length > 0) {
        let search = new URLSearchParams(
          selectedItems.map((s) => ['treatmentItemIds', s.value])
        );
        searchParam.paramTemp = search.toString();
      }
      params.queryParams = {
        limit: params.queryParams.limit,
        orderBy: params.queryParams.orderBy,
        ...searchParam,
      };
      setParams(params);
      itemStatisticsCallApi();
    }
  };

  const onClickSearch = (type) => {
    let searchParam = searchValue;
    if (searchParam.searchStartAt === 'Invalid date') {
      // eslint-disable-next-line unused-imports/no-unused-vars
      const { searchStartAt: deletedKey, ...otherKeys } = searchParam;
      searchParam = otherKeys;
    }

    if (searchParam.searchEndAt === 'Invalid date') {
      // eslint-disable-next-line unused-imports/no-unused-vars
      const { searchEndAt: deletedKey, ...otherKeys } = searchParam;
      searchParam = otherKeys;
    }

    if (type === 'category') {
      delete searchParam.paramTemp;
      if (selectedCategory.length > 0) {
        //searchParam.treatmentCategoryIds = searchParam.treatmentCategoryIds.join(",")
        let search = new URLSearchParams(
          selectedCategory.map((s) => ['treatmentCategoryIds', s.value])
        );
        searchParam.paramTemp = search.toString();
      }
    } else {
      delete searchParam.paramTemp;
      if (selectedItems.length > 0) {
        let search = new URLSearchParams(
          selectedItems.map((s) => ['treatmentItemIds', s.value])
        );
        searchParam.paramTemp = search.toString();
      }
    }

    params.queryParams = {
      limit: params.queryParams.limit,
      orderBy: params.queryParams.orderBy,
      ...searchParam,
    };
    setSearchValue(searchParam);
    setParams(params);
    callApi(type);
  };

  return (
    <div className={`statistics list inquiry`}>
      <div className="page-navi">
        <span className="title">통계</span>
        <span className="title">시수술 통계</span>
      </div>

      <div className="route-top surgery-tab-line">
        <div className="tabwrap">
          <ul>
            <li
              onClick={() => {
                params.orderBy('salesFigures desc');
                setTabName('category');
                onClickSearch('category');
                setSelectedCategory([]);
                setSelectedItems([]);
              }}
              className={`tab ${
                tabName && tabName === 'category' ? 'selected' : ''
              }`}
            >
              <a>시수술 카테고리별</a>
            </li>
            <li
              onClick={() => {
                params.orderBy('salesFigures desc');
                setTabName('item');
                onClickSearch('item');
                setSelectedCategory([]);
                setSelectedItems([]);
              }}
              className={`tab ${
                tabName && tabName === 'item' ? 'selected' : ''
              }`}
            >
              <a>시수술 항목별</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="route-top">
        <div className="search-bar">
          {/* <div className="search-btns">
            <button
              className={`btn btn-normal _small`}
              onClick={() => onClickSelectDate('week')}
            >
              이번 주
            </button>
          </div>
          <div className="search-btns">
            <button
              className={`btn btn-normal _small`}
              onClick={() => onClickSelectDate('month')}
            >
              이번 달
            </button>
          </div>
          <div className="search-btns">
            <button
              className={`btn btn-normal _small`}
              onClick={() => onClickSelectDate('quarter')}
            >
              이번 분기
            </button>
          </div> */}
          <div className="search-item">
            <DatePicker
              className="text-center"
              placeholderText="날짜선택"
              todayButton="오늘"
              maxDate={new Date()}
              value={startAt}
              onChange={onChangeStartAt}
            />
          </div>
          <div className="search-item">-</div>
          <div className="search-item">
            <DatePicker
              className="text-center"
              placeholderText="날짜선택"
              todayButton="오늘"
              maxDate={new Date()}
              value={endAt}
              onChange={onChangeEndAt}
            />
          </div>
          <div className="search-item">
            <MultiSelect
              className="multi-select"
              options={
                tabName && tabName === 'category'
                  ? treatmentItemCategories
                  : treatmentItems
              }
              value={
                tabName && tabName === 'category'
                  ? selectedCategory
                  : selectedItems
              }
              onChange={
                tabName && tabName === 'category'
                  ? setSelectedCategory
                  : setSelectedItems
              }
              labelledBy={'Select'}
              disableSearch
              selectAllLabel={'전체선택'}
              overrideStrings={{
                selectSomeItems:
                  tabName && tabName === 'category'
                    ? '카테고리명'
                    : '시/수술명',
                allItemsAreSelected: '전체선택',
              }}
            />
          </div>
          <div className="search-btns">
            <button
              className="btn btn-basic _small search"
              onClick={() => onClickSearch(tabName)}
            >
              조회
            </button>
            {/* <button
              className="btn btn-basic _small excel"
              disabled={downloadBtnDisabledFlag}
              //onClick={onClickExcelDownload}
              >Excel 내려받기 </button> */}
          </div>
        </div>
      </div>
      <div className="sales-statistics-container">
        <HeaderRowSpanDataTable
          rowKey="no"
          model={model}
          data={data}
          total={total}
          onClickHeaderRow={onClickHeaderRow}
          params={params}
          onParams={onParams}
          bordered={true}
        />
      </div>
    </div>
  );
};

export default observer(SurgeryStatistics);
